<template>
    <div>
        <div class="width100 floatleft borderbottom">
            <div class="floatleft width100 novlucht" v-on:click="select(null)">
                <div
                    style="margin-top: -2px;"
                    class="textcenter padding20 paddingtop30 floatleft padding20"
                >
                    <div
                        v-if="cruiseFlights.results.length <= 0"
                        class="yellow-notification"
                    >
                        Er zijn momenteel geen passende vluchten gevonden, kies
                        ervoor om nu alleen je cruise te boeken of laat ons de
                        vluchten voor je samenstellen.
                    </div>
                    <div v-else>
                        <input
                            type="radio"
                            style="vertical-align: sub; width: 65px"
                            id="noFlight"
                            :value="null"
                            v-model="selectedFlight"
                        />
                        <strong
                            ><span style="margin-left: 20px; color:#333"
                                >Geen vluchten</span
                            ></strong
                        >
                    </div>
                </div>
            </div>

            <div class="floatleft width80"></div>
        </div>
        <div class="clear"></div>
        <div
            class="width100 floatleft borderbottom"
            v-for="(result, index) in cruiseFlights.results"
            :key="'CruiseFlightsRresults' + index"
            v-on:click="select(result)"
        >
            <div class="pricepos floatleft margintop20">
                <div class="prijspos textcenter padding20 paddingtop30">
                    <h1 class="midblauw bold">
                        € {{ result.totalPrice }}
                        <span class="font10">p.p.</span>
                    </h1>
                    <input
                        type="radio"
                        style="width: 65px"
                        :id="'flightSelectedOption' + index"
                        :value="result"
                        v-model="selectedFlight"
                        class="margintop15"
                    />
                </div>
            </div>

            <div class="flightcontainer floatleft width80" style="">
                <div class="floatleft width100" v-if="result.outbound">
                    <FlightCached
                        v-for="(flightout, index) in result.outbound"
                        :key="'outb' + index"
                        :flight="flightout"
                        :index="index"
                    />
                </div>

                <div class="floatleft width100" v-if="result.inbound">
                    <FlightCached
                        v-for="(flightin, index) in result.inbound"
                        :key="'inb' + index"
                        v-if="index === 0"
                        :flight="flightin"
                        :first="true"
                        :index="index"
                    />
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import FlightCached from './FlightCached.vue'

export default {
    name: 'FlightsCached',
    components: {
        FlightCached,
    },
    props: {
        cruiseFlights: Object,
        cruiseID: Number,
    },
    computed: {
        selectedFlight: {
            get: function() {
                return this.$store.state.selectedFlight
            },
            set: function(value) {
                this.$store.state.selectedFlight = value
            },
        },
    },
    methods: {
        select: function(val) {
            this.$store.state.selectedFlight = val
        },
    },
}
</script>

<style scoped></style>
